import LoginForm from '../../../components/Auth/LoginForm';
import './LoginAuthForm.css';
import './login.css';

const LoginPage = () => {
    return (
        <div className="loginPage">
            <LoginForm />
        </div>
    );
};

export default LoginPage;
